// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"b3c53228","251":"d622df8c","348":"c7416ad9","364":"e81b600f","571":"ef93e257"}[chunkId] + ".chunk.js";
};